export default __webpack_public_path__ + "static/media/android.23557226.svg";